<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <CaseACocherLive code="decla1" v-model="sasAssurance.declarationChangement1" :live="liveSasAssurance(9213)" />
      <CaseACocherLive code="decla2" v-model="sasAssurance.declarationChangement2" :live="liveSasAssurance(9214)" />
      <CaseACocherLive code="decla3" v-model="sasAssurance.declarationChangement3" :live="liveSasAssurance(9215)" />
    </v-form>
  </div>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"

export default {
  mixins: [StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasAssurance() {
      return this.sas.sasAssurance
    },
  },
  methods: {
    liveSasAssurance(cle) {
      return { endpoint: "sas-assurance", cle: cle, fileId: this.sasAssurance.id }
    }
  }
}
</script>

<style>
</style>